import(/* webpackMode: "eager" */ "/vercel/path0/src/components/events/EventsComponent.tsx")